import find from 'lodash/find';

import http from '@/js/helpers/http';
import { YMAP_APIKEY } from '@/js/configs';

export default function (successCallback, errorCallback) {
  const urlYandexGeocode = `https://geocode-maps.yandex.ru/1.x/?lang=ru_RU&apikey=${YMAP_APIKEY}`;
  const urlGoogleGeocode = '/local/services/api/geoloc/google_geocode.php';

  const processCoordsGoogle = (latitude, longitude) => {
    http.get(urlGoogleGeocode, {
      latitude,
      longitude,
    })
      .then((data) => {
        let city = '';

        try {
          if (data.response.status === 'OK') {
            const resultArr = data.response.results || [];
            resultArr.forEach((result) => {
              try {
                if (city.length < 1) {
                  if (
                    result.types.indexOf('locality') > -1
                    && result.types.indexOf('political') > -1
                  ) {
                    /**
                     * @param {object} result.address_components
                     * @param {object} addressComponent.types
                     * @param {string} addressComponent.long_name
                     */
                    result.address_components.forEach((addressComponent) => {
                      if (city.length < 1) {
                        if (
                          addressComponent.types.indexOf('locality') > -1
                          && addressComponent.types.indexOf('political') > -1
                        ) {
                          city = addressComponent.long_name;
                        }
                      }
                    });
                  }
                }
              } catch (e) {
                // error
              }
            });
          }
        } catch (e) {
          // error
        }

        if (city.length) {
          successCallback(city, {
            lat: latitude,
            lng: longitude,
          });
        } else {
          errorCallback();
        }
      })
      .catch((error) => {
        errorCallback(error);
      });
  };

  const processCoordsYandex = (latitude, longitude) => {
    http.get(urlYandexGeocode, {
      format: 'json',
      geocode: `${longitude.toString()},${latitude.toString()}`,
    })
      .then((data) => {
        let city = '';

        try {
          /**
           * @param {object} featureMember.GeoObject
           * @param {object} featureMember.GeoObject.metaDataProperty
           * @param {object} featureMember.GeoObject.metaDataProperty.GeocoderMetaData
           * @param {object} featureMember.GeoObject.metaDataProperty.GeocoderMetaData.Address
           */
          data.response.GeoObjectCollection.featureMember.forEach((featureMember) => {
            try {
              if (city.length < 1) {
                const metaDataProperty = featureMember.GeoObject.metaDataProperty;
                const components = metaDataProperty.GeocoderMetaData.Address.Components;

                city = find(components, { kind: 'locality' }).name;
              }
            } catch (e) {
              // error
            }
          });
        } catch (e) {
          // error
        }

        if (city.length) {
          successCallback(city, {
            lat: latitude,
            lng: longitude,
          });
        } else {
          processCoordsGoogle(latitude, longitude);
        }
      })
      .catch(() => {
        processCoordsGoogle(latitude, longitude);
      });
  };

  let timeoutEnd = false;
  const timeout = setTimeout(() => {
    timeoutEnd = true;
    errorCallback();
  }, 10000);

  navigator.geolocation.getCurrentPosition(
    (position) => {
      clearTimeout(timeout);
      if (!timeoutEnd) {
        processCoordsYandex(position.coords.latitude, position.coords.longitude);
      }
    },
    (error) => {
      clearTimeout(timeout);
      if (!timeoutEnd) {
        errorCallback(error);
      }
    },
  );
}
